import Model from 'flarum/common/Model';
export default class Recital extends Model {}
Object.assign(Recital.prototype, {
  recitalTypeId: Model.attribute('recitalTypeId'),
  recitalNumber: Model.attribute('recitalNumber'),
  status: Model.attribute('status'),
  announcementDiscussionId: Model.attribute('announcementDiscussionId'),
  submissionDiscussionId: Model.attribute('submissionDiscussionId'),
  placeholderValues: Model.attribute('placeholderValues'),
  publishStartedAt: Model.attribute('publishStartedAt', Model.transformDate),
  createdAt: Model.attribute('createdAt', Model.transformDate),
  updatedAt: Model.attribute('updatedAt', Model.transformDate),
  user: Model.hasOne('user')
});
flarum.reg.add('pianotell-recitals', 'common/models/Recital', Recital);